import React, { useState, useEffect } from "react";
import "./style.css";
import Search from "../searchBar";
import menuIcon from "./images/menu.svg";
import cartIcon from "./images/cart.png";
import Menu from "./menu";
import { isAuthenticated } from "../../pages/login/auth/auth";
import axios from "axios";
import { API } from "../../Api";

export default function Nav2() {
  const [cart, setCart] = useState(0);

  useEffect(() => {
    const { data } = isAuthenticated();
    if (isAuthenticated()) {
      if (data) {
        axios({
          method: "post",
          url: `${API}cart/getItems`,
          data: {
            user_id: data.user.number,
          },
        }).then((res) => {
          setCart(res.data.data.length);
        });
      }
    } else {
      const cartArr = JSON.parse(localStorage.getItem("cart"));
      if (cartArr) {
        setCart(cartArr.length);
      }
    }
  }, []);

  const [click, setClick] = useState("non");
  function myFunction() {
    setClick("show");
  }
  function update() {
    setClick("non");
  }
  return (
    <div className="nav-2">
      <div className={click}>
        <Menu />
        <button className="cross-btn" onClick={update}></button>
      </div>
      <div className="nav-menu" onClick={myFunction}>
        <img src={menuIcon} alt="menu-icon" />
      </div>
      <Search />
      <div className="cart-icon-div">
        <a href="/cart">
          <img src={cartIcon} alt="icon" width="35px" height="35px" />
          <div className="cart-amount">
            <p>{cart}</p>
          </div>
        </a>
      </div>
    </div>
  );
}
